/** @file Renames an event (ASCII name, unique among events); the current name changes nothing. */
import { defineCommand } from '../defineCommand';
import { defineRename } from '../_shared/defineRename';
import { entityDraft } from '../_shared/entityDraft';

const rename = defineRename({ domain: 'event', kind: 'event', description: 'Rename an event (ASCII name, unique among events).' });

/** event.rename: the defineRename factory, skipped when the event already has the name (R2-13). */
export const command = defineCommand({
  ...rename,
  apply(draft, input, ctx) {
    const event = entityDraft(draft, 'event', ctx.resolve('event', input.target));
    if (event.name !== input.name) rename.apply(draft, input, ctx);
  },
});
